import { render, staticRenderFns } from "./invigilatorPdf.vue?vue&type=template&id=383ae910&scoped=true&"
import script from "./invigilatorPdf.vue?vue&type=script&lang=js&"
export * from "./invigilatorPdf.vue?vue&type=script&lang=js&"
import style0 from "./invigilatorPdf.vue?vue&type=style&index=0&id=383ae910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ae910",
  null
  
)

export default component.exports